import { Link } from "react-router";
import { Markdown } from "@shared/components/Markdown.tsx";
import {
  Loading,
  Skeleton,
  SkeletonText,
} from "@shared/components/Skeleton.tsx";
import { Alert, Button } from "@shared/components/Button.tsx";
import { PageBanner } from "../Layout.tsx";
import { useLegalDoc } from "../useLegalDoc.ts";

export function LegalDocSkeleton() {
  return (
    <Loading label="अटी व नियम लोड होत आहेत…">
      <Skeleton h={26} w="55%" style={{ marginBottom: 20 }} />
      <SkeletonText lines={3} />
      <Skeleton h={20} w="35%" style={{ margin: "26px 0 14px" }} />
      <SkeletonText lines={5} />
      <Skeleton h={20} w="40%" style={{ margin: "26px 0 14px" }} />
      <SkeletonText lines={4} />
    </Loading>
  );
}

export function RulesPage() {
  const doc = useLegalDoc();

  return (
    <>
      <PageBanner title="माहिती, नियम आणि अटी" />
      <div className="container content content--narrow">
        <p className="step-sub">
          नोंदणी करण्यापूर्वी खालील माहिती, अटी आणि स्पर्धेचे नियम काळजीपूर्वक वाचा.
        </p>

        {!doc.loading && doc.fallback && (
          <div style={{ marginBottom: 20 }}>
            <Alert
              tone="warn"
              title="अधिकृत मजकूर सर्व्हरवरून लोड होऊ शकला नाही"
              action={
                <Button
                  size="sm"
                  variant="secondary"
                  icon="refresh"
                  onClick={doc.retry}
                >
                  पुन्हा प्रयत्न करा
                </Button>
              }
            >
              खाली तात्पुरता मजकूर दाखवला आहे.
            </Alert>
          </div>
        )}

        <article className="doc-box doc-box--page">
          {doc.loading ? (
            <LegalDocSkeleton />
          ) : (
            <Markdown source={doc.content} />
          )}
        </article>

        <div className="step-actions">
          <span className="muted">
            नोंदणीच्या पहिल्या पायरीवर हेच नियम मान्य करावे लागतील.
          </span>
          <Link to="/register" className="btn btn-primary btn-md">
            नोंदणी करा →
          </Link>
        </div>
      </div>
    </>
  );
}
